import { IEReservationGroupElementDto } from "modules/groups/dto/IEReservationGroupElementDto";

import { createGroup } from "./group";

export const createGroups = (
  groupsLength: number = 10,
  queuesLength: number = 10
): IEReservationGroupElementDto[] => {
  return Array.from(Array(groupsLength).keys()).map((groupIndex) => {
    return createGroup(groupIndex.toString(), queuesLength);
  });
};
